import type { ICompositeProductInstance } from '../interfaces/ICommon';

export interface IRoleWithProductKey {
  productKey?: string;
  [key: string]: any;
}

const SASE_PRODUCT_TYPE = 'sase';
const HIDDEN_PRODUCT_KEYS = ['secure-access', 'sdwan'];

// Returns true when compositeProductInstances contains an item with productType === 'sase'.
export function shouldHideSaseRoles(
  compositeProductInstances: ICompositeProductInstance[] | null | undefined
): boolean {
  if (
    !compositeProductInstances ||
    !Array.isArray(compositeProductInstances) ||
    compositeProductInstances.length === 0
  ) {
    return false;
  }

  const saseCompositeProduct = compositeProductInstances.find(
    (product) => product.productType?.toLowerCase() === SASE_PRODUCT_TYPE
  );

  return !!saseCompositeProduct;
}

// Hides 'secure-access' and 'sdwan' roles when a 'sase' composite product exists.
export function filterRolesBySaseState<T extends IRoleWithProductKey>(
  roles: T[] | null | undefined,
  compositeProductInstances: ICompositeProductInstance[] | null | undefined
): T[] {
  if (!roles || !Array.isArray(roles)) {
    return [];
  }

  const hideRoles = shouldHideSaseRoles(compositeProductInstances);

  if (!hideRoles) {
    return roles;
  }

  return roles.filter((role) => {
    if (!role.productKey) {
      return true;
    }
    return !HIDDEN_PRODUCT_KEYS.includes(role.productKey);
  });
}
